interface ServerError {
  TokenExpired: string;
}

export const ServerError: ServerError = {
  TokenExpired: "token expired",
};
